
import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TimeRangeSelectorProps {
  timeRange: 'month' | 'quarter' | 'year';
  onTimeRangeChange: (range: 'month' | 'quarter' | 'year') => void;
  className?: string;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({ 
  timeRange, 
  onTimeRangeChange,
  className 
}) => {
  return (
    <div className={cn("flex space-x-1 bg-gray-100 dark:bg-gray-800 rounded-lg p-1 mb-2 w-fit", className)}>
      <Button 
        variant={timeRange === 'month' ? "default" : "ghost"}
        size="sm"
        className={cn(
          "text-xs h-7 rounded-md",
          timeRange === 'month' ? 'shadow-sm' : 'text-gray-600 dark:text-gray-400'
        )}
        onClick={() => onTimeRangeChange('month')}
      >
        Month
      </Button>
      <Button 
        variant={timeRange === 'quarter' ? "default" : "ghost"}
        size="sm"
        className={cn(
          "text-xs h-7 rounded-md",
          timeRange === 'quarter' ? 'shadow-sm' : 'text-gray-600 dark:text-gray-400'
        )}
        onClick={() => onTimeRangeChange('quarter')}
      >
        Quarter
      </Button>
      <Button 
        variant={timeRange === 'year' ? "default" : "ghost"}
        size="sm"
        className={cn(
          "text-xs h-7 rounded-md",
          timeRange === 'year' ? 'shadow-sm' : 'text-gray-600 dark:text-gray-400'
        )}
        onClick={() => onTimeRangeChange('year')}
      >
        Year
      </Button>
    </div>
  );
};

export default TimeRangeSelector;
